export const environment = {
  production: false,
  backendURL: 'https://myaccount-stage.app.karcher.com/api/v1',
  translation: 'https://myaccount-stage.app.karcher.com/translation',
  configuration: 'https://myaccount-stage.app.karcher.com',
  corporateUrl: 'https://cms-stage.app.kaercher.com',
  loginUrl: 'https://auth.test.karcher.com',
  notFoundUrl: 'https://www.kaercher.com/int/404.html',
  clientId: 'mykaercher-web',
  clientSecret: 'wqUKZTsBWUs6mdIv2Hh5nLSNMQdwcjxbSYzbkT7v',
  rock: 'https://ak-rock-stage-srm-app.s3.eu-central-1.amazonaws.com/remoteEntry.js',
  rrm: 'https://stage-rrm-app.s3.eu-central-1.amazonaws.com/remoteEntry.js',

  analyticsUrl:
    'https://assets.adobedtm.com/a13643f4feff/095e7dd7396b/launch-0d2ababb54fa-staging.min.js',
  recaptcha: {
    siteKey: '6Lf5nxsrAAAAAE9QwMKYxHlJw-akltsLFj_cVAQJ',
  },
  newMyk:{
    "en-IE": "https://karcher.preview.website.karcher.com/ie/en/customer-account",
    "de-DE": "https://karcher.preview.website.karcher.com/de/de/customer-account",
    "de-AT": "https://karcher.preview.website.karcher.com/at/de/customer-account",
    "en-US": "https://karcher.preview.website.karcher.com/us/en/customer-account",
    "en-GB": "https://karcher.preview.website.karcher.com/gb/en/customer-account",
    "tr-TR": "https://karcher.preview.website.karcher.com/tr/tr/customer-account",
    "en-MY": "https://karcher.preview.website.karcher.com/my/en/customer-account",
    "th-TH": "https://karcher.preview.website.karcher.com/th/th/customer-account",
    "vi-VN": "https://karcher.preview.website.karcher.com/vn/vi/customer-account",
    "ro-RO": "https://karcher.preview.website.karcher.com/ro/ro/cont-client",
    "nl-BE": "https://karcher.preview.website.karcher.com/be/nl/account",
    "fr-BE": "https://karcher.preview.website.karcher.com/be/fr/account",
    "el-GR": "https://karcher.preview.website.karcher.com/gr/el/account",
    "en-NZ": "https://karcher.preview.website.karcher.com/nz/en/account",
    "de-CH": "https://karcher.preview.website.karcher.com/ch/de/account",
    "fr-CH": "https://karcher.preview.website.karcher.com/ch/fr/account",
    "nl-NL": "https://karcher.preview.website.karcher.com/nl/nl/account",
    "en-AU": "https://karcher.preview.website.karcher.com/au/en/account",
    "lv-LV": "https://karcher.preview.website.karcher.com/lv/lv/customer-account",
    "lt-LT": "https://karcher.preview.website.karcher.com/lt/lt/account",
    "et-EE": "https://karcher.preview.website.karcher.com/ee/et/kliendikonto"
  }
};
